import React, {Component} from 'react';

export default class Service extends Component{
    render(){

        return (
            <div id='train_list'>{this.props.children}</div>
        )
    }
}
